import {
  Card,
  InlineStack,
  Text,
  Box,
  FormLayout,
  Page,
  Icon,
  Spinner,
} from "@shopify/polaris";
import {
  BookIcon,
  CategoriesIcon,
  ClockIcon,
  InventoryFilledIcon,
  InventoryIcon,
  StatusActiveIcon,
  TeamIcon,
  XIcon,
} from "@shopify/polaris-icons";
import React, { useState, useCallback, useEffect } from "react";
import axios from "../Assets/Lib/axios";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LineChart,
  Line,
  ResponsiveContainer,
  PieChart,
  Pie,
  AreaChart,
  Area,
  RadialBarChart,
  PolarGrid,
  PolarAngleAxis,
  RadialBar,
  Cell,
} from "recharts";
const Dashboard = () => {
  const [statistics, setStatistics] = useState({
    users: "",
    professors: "",
    schools: "",
    universities: "",
    courses: "",
    most_purchases_courses: [],
    most_booked_professors: [],
    total_requests: "",
    pending_requests: "",
    approved_requests: "",
    rejected_requests: "",
    revenue: [],
  });
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    axios
      .get("dashboard/statistics")
      .then((result) => {
        let response = result?.data?.data;
        setStatistics({
          users: response?.total_users !== null ? response?.total_users : "",
          professors:
            response?.total_professors !== null
              ? response?.total_professors
              : "",
          schools:
            response?.total_schools !== null ? response?.total_schools : "",
          universities:
            response?.total_universities !== null
              ? response?.total_universities
              : "",
          courses:
            response?.total_courses !== null ? response?.total_courses : "",
          total_requests:
            response?.total_tutoring_requests !== null
              ? response?.total_tutoring_requests
              : "",
          pending_requests:
            response?.pending_requests !== null
              ? response?.pending_requests
              : "",
          approved_requests:
            response?.approved_requests !== null
              ? response?.approved_requests
              : "",
          rejected_requests:
            response?.rejected_requests !== null
              ? response?.rejected_requests
              : "",
          most_purchases_courses: response?.most_purchased_courses?.length
            ? response?.most_purchased_courses.map((element) => ({
                value: parseInt(element.purchase_count),
                course: getFirstNonNullValue(element?.title),
              }))
            : [],
          most_booked_professors: response?.most_booked_professors?.length
            ? response?.most_booked_professors.map((element) => ({
                value: parseInt(element.requests_count),
                professor: getFirstNonNullValue(element?.name),
              }))
            : [],
          //   revenue: [
          //     { revenue: "course", value: 10 },
          //     { revenue: "note", value: 10 },
          //     { revenue: "tutoring", value: 10 },
          //   ],
          revenue: response?.revenue_breakdown?.length
            ? response?.revenue_breakdown.map((element, index) => ({
                value: parseInt(element.total),
                revenue: element?.name,
                color:
                  index === 0 ? "#dbcdf0" : index === 1 ? "#f2c6df" : "#f8d9c4",
              }))
            : [],
        });
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  }, []);
  return (
    <Page title="Dashboard" fullWidth>
      {!isLoading ? (
        <FormLayout>
          <FormLayout.Group>
            <Card>
              <InlineStack align="space-between" blockAlign="center">
                <Box
                  background="success-subdued"
                  borderRadius="full"
                  padding="2"
                  width="50px"
                  height="50px"
                  display="flex"
                  alignitems="center"
                  justifycontent="center"
                >
                  <TeamIcon />
                </Box>
                <Box textalign="end">
                  <Text as="p" variant="bodySm" tone="subdued">
                    Users
                  </Text>
                  <Text variant="headingXl" as="h4">
                    {statistics.users}
                  </Text>
                </Box>
              </InlineStack>
            </Card>
            <Card>
              <InlineStack align="space-between" blockAlign="center">
                <Box
                  background="success-subdued"
                  borderRadius="full"
                  padding="2"
                  width="50px"
                  height="50px"
                  display="flex"
                  alignitems="center"
                  justifycontent="center"
                >
                  <TeamIcon />
                </Box>
                <Box textalign="end">
                  <Text as="p" variant="bodySm" tone="subdued">
                    Professors
                  </Text>
                  <Text variant="headingXl" as="h4">
                    {statistics.professors}
                  </Text>
                </Box>
              </InlineStack>
            </Card>
            <Card>
              <InlineStack align="space-between" blockAlign="center">
                <Box
                  background="success-subdued"
                  padding="2"
                  width="50px"
                  height="50px"
                  display="flex"
                  alignitems="center"
                  justifycontent="center"
                >
                  <InventoryIcon />
                </Box>
                <Box textalign="end">
                  <Text as="p" variant="bodySm" tone="subdued">
                    Schools
                  </Text>
                  <Text variant="headingXl" as="h4">
                    {statistics.schools}
                  </Text>
                </Box>
              </InlineStack>
            </Card>
            <Card>
              <InlineStack align="space-between" blockAlign="center">
                <Box
                  background="success-subdued"
                  borderRadius="full"
                  padding="2"
                  width="50px"
                  height="50px"
                  display="flex"
                  alignitems="center"
                  justifycontent="center"
                >
                  <InventoryIcon />
                </Box>
                <Box textalign="end">
                  <Text as="p" variant="bodySm" tone="subdued">
                    Universities
                  </Text>
                  <Text variant="headingXl" as="h4">
                    {statistics.universities}
                  </Text>
                </Box>
              </InlineStack>
            </Card>
            <Card>
              <InlineStack align="space-between" blockAlign="center">
                <Box
                  background="success-subdued"
                  borderRadius="full"
                  padding="2"
                  width="50px"
                  height="50px"
                  display="flex"
                  alignitems="center"
                  justifycontent="center"
                >
                  <BookIcon />
                </Box>
                <Box textalign="end">
                  <Text as="p" variant="bodySm" tone="subdued">
                    Courses
                  </Text>
                  <Text variant="headingXl" as="h4">
                    {statistics.courses}
                  </Text>
                </Box>
              </InlineStack>
            </Card>
          </FormLayout.Group>

          <FormLayout.Group>
            <Card sectioned>
              <FormLayout>
                <Text variant="headingMd" as="h6">
                  MOST PURCHASED COURSES
                </Text>

                <ResponsiveContainer width="100%" height={400}>
                  <BarChart
                    width={600}
                    height={600}
                    data={statistics.most_purchases_courses}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" opacity={0.7} />
                    <XAxis
                      dataKey="course"
                      tickFormatter={(value) =>
                        value.length > 10
                          ? value.substring(0, 10) + "..."
                          : value
                      }
                    />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="value" fill="#c9e4df" />
                  </BarChart>
                </ResponsiveContainer>
              </FormLayout>
            </Card>
            <Card sectioned>
              <FormLayout>
                <Text variant="headingMd" as="h6">
                  MOST BOOKED PROFESSORS
                </Text>

                <ResponsiveContainer width="100%" height={400}>
                  <BarChart
                    width={600}
                    height={600}
                    data={statistics.most_booked_professors}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" opacity={0.7} />
                    <XAxis
                      dataKey="professor"
                      tickFormatter={(value) =>
                        value.length > 10
                          ? value.substring(0, 10) + "..."
                          : value
                      }
                    />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="value" fill="#c5def2" />
                  </BarChart>
                </ResponsiveContainer>
              </FormLayout>
            </Card>
          </FormLayout.Group>

          <Card sectioned>
            <FormLayout>
              <Text variant="headingMd" as="h6">
                REQUESTS
              </Text>

              <FormLayout.Group>
                <Card>
                  <InlineStack align="space-between" blockAlign="center">
                    <Box
                      background="success-subdued"
                      borderRadius="full"
                      padding="2"
                      width="50px"
                      height="50px"
                      display="flex"
                      alignitems="center"
                      justifycontent="center"
                    >
                      <CategoriesIcon />
                    </Box>
                    <Box textalign="end">
                      <Text as="p" variant="bodySm" tone="subdued">
                        Total Requests
                      </Text>
                      <Text variant="headingXl" as="h4">
                        {statistics.total_requests}
                      </Text>
                    </Box>
                  </InlineStack>
                </Card>
                <Card>
                  <InlineStack align="space-between" blockAlign="center">
                    <Box
                      background="success-subdued"
                      borderRadius="full"
                      padding="2"
                      width="50px"
                      height="50px"
                      display="flex"
                      alignitems="center"
                      justifycontent="center"
                    >
                      <ClockIcon />
                    </Box>
                    <Box textalign="end">
                      <Text as="p" variant="bodySm" tone="subdued">
                        Pending Requests
                      </Text>
                      <Text variant="headingXl" as="h4">
                        {statistics.pending_requests}
                      </Text>
                    </Box>
                  </InlineStack>
                </Card>
              </FormLayout.Group>
              <FormLayout.Group>
                <Card>
                  <InlineStack align="space-between" blockAlign="center">
                    <Box
                      background="success-subdued"
                      padding="2"
                      width="50px"
                      height="50px"
                      display="flex"
                      alignitems="center"
                      justifycontent="center"
                    >
                      <StatusActiveIcon />
                    </Box>
                    <Box textalign="end">
                      <Text as="p" variant="bodySm" tone="subdued">
                        Approved Requests
                      </Text>
                      <Text variant="headingXl" as="h4">
                        {statistics.approved_requests}
                      </Text>
                    </Box>
                  </InlineStack>
                </Card>
                <Card>
                  <InlineStack align="space-between" blockAlign="center">
                    <Box
                      background="success-subdued"
                      borderRadius="full"
                      padding="2"
                      width="50px"
                      height="50px"
                      display="flex"
                      alignitems="center"
                      justifycontent="center"
                    >
                      <XIcon />
                    </Box>
                    <Box textalign="end">
                      <Text as="p" variant="bodySm" tone="subdued">
                        Rejected Requests
                      </Text>
                      <Text variant="headingXl" as="h4">
                        {statistics.rejected_requests}
                      </Text>
                    </Box>
                  </InlineStack>
                </Card>
              </FormLayout.Group>
            </FormLayout>
          </Card>

          <Card sectioned>
            <FormLayout>
              <Text variant="headingMd" as="h6">
                REVENUE
              </Text>

              <ResponsiveContainer width="100%" height={400}>
                <PieChart>
                  <Pie
                    data={statistics.revenue}
                    dataKey="value"
                    nameKey="revenue"
                    outerRadius="80%"
                    fill="#c9e4df"
                    label
                  >
                    {statistics.revenue.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={entry.color || "#c9e4df"}
                      />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </FormLayout>
          </Card>
        </FormLayout>
      ) : (
        <div className="spinnerContainer">
          <div className="vertical-center">
            <Spinner size="large" />
          </div>
        </div>
      )}
    </Page>
  );
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};
export default Dashboard;
